module.exports = __webpack_public_path__ + "static/Illustration_clickUp-051ee270ee70fc35bb3cb06b87e8b00c.png";